(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript-panel.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript-panel.js');
'use strict';

const {
  useEffect,
  useRef
} = React;
const {
  fetchTranscriptStatus,
  orderTranscript
} = svs.myProfile.react.store.pd.actions;
const {
  getMessageByCode
} = svs.myProfile.react.shared.errorMessages;
const {
  TranscriptCard,
  TranscriptCardHistory
} = svs.myProfile.react.pages.myInformation.transcript.transcript;
const {
  showOrderTranscriptError
} = svs.myProfile.react.shared.dialogs;

const TranscriptPanel = _ref => {
  let {
    isTranscriptLink
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const transcriptStatuses = ReactRedux.useSelector(state => state.playerDetails.transcriptOrderStatus);
  const customerTranscript = transcriptStatuses.find(item => item.OrderType === '1');
  const gameTranscript = transcriptStatuses.find(item => item.OrderType === '2');
  const transactionTranscript = transcriptStatuses.find(item => item.OrderType === '3');
  const transcriptRef = useRef(null);
  const handleOrderClick = async type => {
    const response = await dispatch(orderTranscript(type));
    if (response.error) {
      var _response$payload;
      const errorCode = (response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : _response$payload.code) || null;
      const errorText = errorCode ? getMessageByCode(errorCode) : null;
      showOrderTranscriptError(errorText);
    }
  };
  useEffect(() => {
    if (isTranscriptLink && transcriptRef) {
      transcriptRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isTranscriptLink]);
  useEffect(() => {
    dispatch(fetchTranscriptStatus());
  }, [dispatch]);
  return React.createElement("div", {
    className: "scroll-margin-transcript",
    ref: transcriptRef
  }, React.createElement("div", {
    className: "padding-bottom-3"
  }, React.createElement("h2", {
    className: "align-center h2 margin-bottom-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, " Registerutdrag ")), React.createElement(TranscriptCard, {
    handleOrderClick: handleOrderClick,
    transcript: customerTranscript
  }), React.createElement("div", {
    className: "margin-v-1"
  }, React.createElement(TranscriptCardHistory, {
    handleOrderClick: handleOrderClick,
    orderNumber: "2",
    text: "Mina spel",
    transcript: gameTranscript
  })), React.createElement(TranscriptCardHistory, {
    handleOrderClick: handleOrderClick,
    orderNumber: "3",
    text: "Kontohistorik",
    transcript: transactionTranscript
  })));
};
svs.myProfile.react.pages.myInformation.transcript.TranscriptPanel = TranscriptPanel;

 })(window);